import { useContext, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { useUserLocation } from '../../hooks';
import {
  ErrorBoundary, FacilitatorPromotionNotice, MaintenanceNoticeModal, ScrollToTop, UserLocationSettings,
} from '../../components';
import { AppDataContext } from '../../context';
import type { UserMetaDataResponse } from '../../types';

const IndexView = () => {
  const [userHasRegisteredLocation, setUserHasRegisteredLocation] = useState<boolean>(true);

  const { authenticatedUser } = useContext(AppDataContext);
  const { handleCheckIfUserHasRegisteredLocation } = useUserLocation({ authenticatedUser });

  useEffect(() => {
    if (localStorage.getItem('locationDataRegistered') === 'true') {
      return;
    }

    handleCheckIfUserHasRegisteredLocation((response: UserMetaDataResponse) => {
      if (response?.country) {
        localStorage.setItem('locationDataRegistered', 'true');
      } else {
        setUserHasRegisteredLocation(false);
      }
    });
  }, []);

  return (
    <>
      <ScrollToTop />
      <ErrorBoundary>
        <MaintenanceNoticeModal />
        <FacilitatorPromotionNotice />
        <UserLocationSettings
          userHasRegisteredLocation={userHasRegisteredLocation}
          setUserHasRegisteredLocation={setUserHasRegisteredLocation}
          authenticatedUser={authenticatedUser}
        />
        <Outlet />
      </ErrorBoundary>
    </>
  );
};

export default IndexView;
